import MentionsLegales from "../Mentions-legal/mentions-legal";

export default function IndexPage() {
  return (
    <div className="index-page">
      <MentionsLegales
        siteUrl="https://azureaprintsolutions.com/"
        nomSociete="AZUREA PRINT & SOLUTIONS"
        capital="1 000 €"
        villeRcs="MONTAUROUX"
        adresse="150 CHEMIN DU MOULIN, 83440 MONTAUROUX France"
        siren="933 692 691"
        responsablePublication="Gregory KIENER GREGORY ANDREA JEAN-PAUL"
        hebergeurNom="OVH SAS"
        hebergeurCapital="10 000 000 €"
        hebergeurAdresse="2, Rue Kellermann 59100 Roubaix"
      />
    </div>
  );
}
